module.exports = __webpack_public_path__ + "assets/img/structure-c2764d55.png";